import type { SubscriptionStatus, SubscriptionType } from "common/types";

import type { FunctionComponent, SVGProps } from "react";

import AgencyGradientIcon from "assets/icons/plans/agency-gradient.svg?react";
import AgencyWhiteIcon from "assets/icons/plans/agency-white.svg?react";
import AvatarGradientIcon from "assets/icons/plans/avatar-gradient.svg?react";
import AvatarWhiteIcon from "assets/icons/plans/avatar-white.svg?react";
import OutreachGradientIcon from "assets/icons/plans/outreach-gradient.svg?react";
import OutreachWhiteIcon from "assets/icons/plans/outreach-white.svg?react";

export const AGENCY_INCLUDED_SEATS =
  import.meta.env.MODE === "production" ? 20 : 2;

export const PRICING_PLANS: Record<
  SubscriptionType,
  {
    name: string;
    description: string;
    altDescription: string;
    icon: FunctionComponent<SVGProps<SVGSVGElement>>;
    gradientIcon: FunctionComponent<SVGProps<SVGSVGElement>>;
    tooltipText: {
      currentPrice: string;
      newPrice: string;
      currentQuantity: string;
      newQuantity: string;
    };
  }
> = {
  agency: {
    name: "Agency Plan",
    description: "Manage your clients' profiles across multiple workspaces",
    altDescription: "Manage your clients' accounts across multiple workspaces",
    icon: AgencyWhiteIcon,
    gradientIcon: AgencyGradientIcon,
    tooltipText: {
      currentPrice:
        "The current recurring price for your Agency Plan subscription. Includes a baseline number of seats",
      newPrice:
        "The new recurring price for your Agency Plan subscription. Includes a baseline number of seats",
      newQuantity:
        "The new number of seats included in your subscription. Does not include Outreach Avatars",
      currentQuantity:
        "The current number of seats included in your subscription. Does not include Outreach Avatars",
    },
  },
  user: {
    name: "Outreach Seat",
    description: "Grow your LinkedIn network with fully automated campaigns",
    altDescription:
      "Connect your LinkedIn profiles to Aimfox and start your outbound",
    icon: OutreachWhiteIcon,
    gradientIcon: OutreachGradientIcon,
    tooltipText: {
      currentPrice:
        "The current recurring price for your Outreach Seat subscription",
      newPrice:
        "The new recurring price for your Outreach Seat subscription. This amount will be deducted on your next billing date",
      newQuantity:
        "The new number of Outreach Seats included in your subscription. Does not include Outreach Avatars",
      currentQuantity:
        "The current number of Outreach Seats included in your subscription. Does not include Outreach Avatars",
    },
  },
  rental: {
    name: "Outreach Avatar",
    description: "Scale your LinkedIn outreach with rented accounts",
    altDescription:
      "Rent and brand ready-to-go LinkedIn profiles. Scale your campaigns today!",
    icon: AvatarWhiteIcon,
    gradientIcon: AvatarGradientIcon,
    tooltipText: {
      currentPrice:
        "The current recurring price for your Outreach Avatar subscription",
      newPrice:
        "The new recurring price for your Outreach Avatar subscription. This amount will be deducted on your next billing date",
      newQuantity:
        "The new number of Outreach Avatars included in your subscription. Avatars automatically come with their own seats, which are included in this price",
      currentQuantity:
        "The current number of Outreach Avatars included in your subscription. Avatars automatically come with their own seats, which are included in this price",
    },
  },
} as const;

export const SUBSCRIPTION_STATUSES: Record<SubscriptionStatus, string> = {
  in_trial: "Trial",
  active: "Active",
  non_renewing: "Non Renewing",
  cancelled: "Cancelled",
} as const;
